import { ChangeEvent, useState } from "react";

import { DateRange } from "./types";

type DateFilterProps = {
  onSave: (data: DateRange) => void;
  defaultValue?: DateRange;
};

const DateFilter = ({ onSave, defaultValue }: DateFilterProps) => {
  const [fromDate, setFromDate] = useState(defaultValue?.from || "");
  const [toDate, setToDate] = useState(defaultValue?.to || "");
  const [includeNulls, setIncludeNulls] = useState(
    defaultValue?.includeNulls || false
  );

  const handleFromDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newFromDate = e.target.value;
    setFromDate(newFromDate);

    // If toDate is empty or fromDate is greater than toDate, update toDate
    let updatedToDate = toDate;

    if (toDate && newFromDate > toDate) {
      updatedToDate = newFromDate;
      setToDate(updatedToDate);
    }

    onSave({
      from: newFromDate,
      to: updatedToDate,
      includeNulls
    });
  };

  const handleToDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newToDate = e.target.value;
    setToDate(newToDate);

    onSave({
      from: fromDate,
      to: newToDate,
      includeNulls
    });
  };

  const handleIncludeNullsChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newIncludeNulls = e.target.checked;
    setIncludeNulls(newIncludeNulls);

    onSave({
      from: fromDate,
      to: toDate,
      includeNulls: newIncludeNulls
    });
  };

  return (
    <div className="flex flex-col flex-1 min-h-0 mt-3">
      <div className="space-y-4">
        {/* From section */}
        <div className="space-y-3">
          <span className="text-sm font-bold">From</span>
          <div className="space-y-2">
            <input
              type="date"
              value={fromDate}
              onChange={handleFromDateChange}
              className="w-full h-[40px] px-3 border border-gainsboro rounded-md text-sm"
              aria-label="From Date"
            />
          </div>
        </div>

        {/* Until section */}
        <div className="space-y-3">
          <span className="text-sm font-bold">Until</span>
          <div className="space-y-2">
            <input
              type="date"
              value={toDate}
              min={fromDate || undefined}
              onChange={handleToDateChange}
              className="w-full h-[40px] px-3 border border-gainsboro rounded-md text-sm"
              aria-label="To Date"
            />
          </div>
        </div>

        {/* Include Nulls checkbox */}
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={includeNulls}
            onChange={handleIncludeNullsChange}
            className="rounded border-gray-300"
          />
          <span className="text-xs text-txtBody font-semibold">
            Include Nulls
          </span>
        </label>
      </div>
    </div>
  );
};

export default DateFilter;
